import { render, staticRenderFns } from "./CheckRevenuePanel.vue?vue&type=template&id=245437c1&scoped=true"
import script from "./CheckRevenuePanel.vue?vue&type=script&lang=js"
export * from "./CheckRevenuePanel.vue?vue&type=script&lang=js"
import style0 from "./CheckRevenuePanel.vue?vue&type=style&index=0&id=245437c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245437c1",
  null
  
)

export default component.exports